import { render, staticRenderFns } from "./RandomStyle.vue?vue&type=template&id=6e4e15ff&scoped=true&"
import script from "./RandomStyle.vue?vue&type=script&lang=js&"
export * from "./RandomStyle.vue?vue&type=script&lang=js&"
import style0 from "./RandomStyle.vue?vue&type=style&index=0&id=6e4e15ff&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4e15ff",
  null
  
)

export default component.exports